import { render, staticRenderFns } from "./invoiceApplyDetailList.vue?vue&type=template&id=b8c94620&scoped=true"
import script from "./invoiceApplyDetailList.vue?vue&type=script&lang=js"
export * from "./invoiceApplyDetailList.vue?vue&type=script&lang=js"
import style0 from "./invoiceApplyDetailList.vue?vue&type=style&index=0&id=b8c94620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c94620",
  null
  
)

export default component.exports